























































































































































































import {Component, Prop, PropSync, Vue, Watch} from 'vue-property-decorator';
import { DxValidationGroup } from 'devextreme-vue';
import DxTagBox from 'devextreme-vue/tag-box';
import DxPopup from 'devextreme-vue/popup';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxSelectBox from 'devextreme-vue/select-box';

import DButton from '@/components/DButton/button.vue';
import DTextbox from '@/components/DTextbox/textbox.vue';
import DTextarea from '@/components/DTextarea/textarea.vue';
import DSelectbox from '@/components/DSelectbox/selectbox.vue';
import TableGrid from '@/components/TableGrid/grid.vue';
import ElementTabs from "@/components/ElTabs/tabs.vue";
import TreeDropDownBox from '@/components/TreeDropDownBox/tree-drop-down-box.vue';
import { EcoFilialSelectionType, EcoNodeSelectionType } from '@/services/models-service';

import AuthService from '@/services/auth_service';
import ShareService from '@/services/share-service';
import YearService from '@/services/years-service';
import AcceptService from '@/services/accept-service';
import {AcceptData, EcoObjectType} from '@/services/models-service';
import UserService, { User, UserEcoHeatNode } from '@/services/data/user_manager';
import notify_service from '@/services/notify_service';
import EmailTemplateService from '@/services/email-template-service';
import EcoObjectsService from '@/services/eco-objects-service';
import UserAccessService from '@/services/user_access_service';

import _ from 'lodash';
import getGridInstance from '@/utils/grid-instance';
import UserManagerService from "@/services/data/user_manager";

@Component({
  name: 'EmailBlock',
  components: {
    DxPopup,
    DxValidationGroup,
    DTextbox,
    DButton,
    TableGrid,
    ElementTabs,
    DxSelectBox,
    DxCheckBox,
    DxTagBox,
    DTextarea,
    DSelectbox,
    TreeDropDownBox,
  }
})

export default class extends Vue {
  @PropSync('extAccept') public accept!: AcceptData;
  @Prop() public cut_ds!: any[];

  public shareService = ShareService;
  public authService = AuthService;
  public emailTemplateService = EmailTemplateService;
  public userService = UserService;
  public acceptService = AcceptService;
  public ecoObjectsService = EcoObjectsService;

  public data_source: any = [];
  public year_ds = YearService.YearList;

  public users_ds: User[] = [];
  public heat_nodes_columns: any[] = [];
  public users_columns: any[] = [];
  public checked_objects: any[] = [];
  public checked_nodes_ids: any[] = [];
  public checked_users: any[] = [];

  public emails: string[] = [];
  public email_content: string | null = null;
  public template: any = {
    id: null,
    content: ''
  };
  public permissions: any = {};
  public userAccessFilterType: 'edit' | 'read' = 'edit';
  public allUserAccess: any = {};
  public filialNodeMap: Record<string, number[]> = {}; 
  public treeSelection: EcoFilialSelectionType[] = [];

  // --- ДОБАВИТЬ getter/setter checked_nodes для TypeScript ---
  get checked_nodes(): number[] {
    // Собираем выбранные id ТУ из treeSelection
    const selected: number[] = [];
    this.treeSelection.forEach(filial => {
      filial.nodes.forEach(node => {
        if (node.check) selected.push(node.id);
      });
    });
    return selected;
  }
  set checked_nodes(val: number[]) {
    // Устанавливаем check для соответствующих узлов в treeSelection
    this.treeSelection.forEach(filial => {
      filial.nodes.forEach(node => {
        node.check = val.includes(node.id);
      });
    });
  }
  // --- КОНЕЦ ДОБАВЛЕНИЯ ---

  async created() {
    await this.loadUsers();
    this.initColumns();
    this.getFilials(true);
    await this.loadAllUserAccess();
  }

  async loadUsers() {
    try {
      const resp = await this.userService.userCrud.get();

      if (resp?.data) {
        this.users_ds = _.cloneDeep(resp.data);
      }

    } catch (e) {
      notify_service.error('Ошибка загрузки списка пользователей')
    }
  }

  async loadAllUserAccess() {
    this.allUserAccess = await UserAccessService.getAllUserAccess() || {};
    // Построим карту филиал -> [nodeId]
    this.filialNodeMap = {};
    if (this.data_source && this.data_source.length) {
      (this.data_source as Array<{ filial_name: string; id: number }>).forEach((node: { filial_name: string; id: number }) => {
        const filialName: string = String(node.filial_name);
        if (!this.filialNodeMap[filialName]) {
          this.filialNodeMap[filialName] = [];
        }
        this.filialNodeMap[filialName].push(Number(node.id));
      });
    }
  }

  get relative_users() {
    if (!this.accept.id_cut) {
      return [];
    }
    if (this.checked_nodes.length > 0) {
      // Фильтрация пользователей по выбранным ТУ и типу доступа
      return this.users_ds.filter((user: any) => {
        const userAccess = this.allUserAccess[user.id];
        if (!userAccess) return false;
        let hasAccess = false;
        for (const nodeId of this.checked_nodes as number[]) {
          if (this.userAccessFilterType === 'edit') {
            if (userAccess.edit_nodes && (userAccess.edit_nodes as number[]).includes(nodeId)) {
              hasAccess = true;
              break;
            }
          } else if (this.userAccessFilterType === 'read') {
            // Только если нет edit, но есть read
            if (
              userAccess.read_nodes && (userAccess.read_nodes as number[]).includes(nodeId) &&
              (!userAccess.edit_nodes || !(userAccess.edit_nodes as number[]).includes(nodeId))
            ) {
              hasAccess = true;
              break;
            }
          }
        }
        return hasAccess;
      });
    }
    return [];
  }

  // Выбор всех ТУ филиала одной галочкой
  selectAllNodesOfFilial(filialName: string) {
    if (!this.filialNodeMap[filialName]) return;
    const nodeIds: number[] = this.filialNodeMap[filialName];
    // Если все уже выбраны — снять выбор, иначе выбрать все
    const allSelected = nodeIds.every((id: number) => (this.checked_nodes as number[]).includes(id));
    if (allSelected) {
      this.checked_nodes = (this.checked_nodes as number[]).filter((id: number) => !nodeIds.includes(id));
    } else {
      // Не используем spread, а через concat и фильтрацию уникальных
      this.checked_nodes = Array.from(new Set((this.checked_nodes as number[]).concat(nodeIds)));
    }
  }

  async loadFilialNodesFlat() {

  }
  async getFilials(force_update: boolean = false) {
    if (force_update) {
      this.checked_nodes = [];
      this.data_source = [];
      this.$forceUpdate();
    }

    if (_.isNil(this.accept.id_year) || _.isNil(this.accept.id_cut)) {
      return
    }

    const year = this.year_ds.find((x) => {
      return x.id === this.accept.id_year
    })

    const cut = this.cut_ds.find((x: any) => {
      return x.id === this.accept.id_cut
    })

    if (!year || !cut) {
      return
    }

    try {
      const resp = await this.ecoObjectsService.get_filial_nodes_flat(cut.id_eco_version, year.name, []);

      if (!resp?.data) {
        return
      }

      this.permissions = UserAccessService.checkAccept();

      this.data_source = resp?.data?.filter((node: any) => {
        return this.permissions.hasOwnProperty(node.id) && this.permissions[node.id].hasOwnProperty('accept__mailing') && this.permissions[node.id]['accept__mailing']
      });

    } catch (e) {
      //
    }

  }

  get readyForSend() {
    return this.emails.length > 0 && this.email_content;
  }

  private initColumns() {

    this.heat_nodes_columns = [{
      dataField: "id",
      dataType: "string",
      visible: false,
    },

      {
      dataField: "filial_name",
      dataType: "string",
      caption: "Филиал",
    },
      {
        dataField: "name",
        dataType: "string",
        caption: "Теловой узел",
      },
      {
        dataField: "accepted",
        dataType: "boolean",
        visible: false
      },
    ];

    this.users_columns = [
      {
        dataField: 'id',
        visible: false
      },
      {
        dataField: 'id_eco_heat_nodes',
        caption: 'Тепловые узлы',
        calculateCellValue: this.showHeatNodes,
      },
      {
        dataField: 'full_name',
        caption: 'Полное имя'
      },
      {
        dataField: 'email',
        caption: 'E-mail',
        dataType: 'string',
      },
    ]

  }

  // Вывести имена ТУ в виде списка через запятую
  showHeatNodes(user: any): string {
    return user.eco_heat_nodes.filter((userNode: UserEcoHeatNode) => {
      // Не показывать ТУ, привязанные к пользователю, но не выбранные в списке слева
      return this.checked_nodes.indexOf(userNode.id_eco_heat_node) !== -1;
    }).map( (userNode: UserEcoHeatNode) => {
      const ecoNode = this.data_source?.find((node: any)=> node.id === userNode.id_eco_heat_node);
      return ecoNode?.name || ''
    }).join(', ');
  }

  async updateMarkedNodes() {
    if (this.accept.id_cut && this.accept.id_year) {
      const response = await this.ecoObjectsService.checkAcceptStatus(this.accept.id_cut, this.accept.id_year);
      if (response) this.data_source = response.filter((node: any) =>
        this.permissions.hasOwnProperty(node.id) && this.permissions[node.id].hasOwnProperty('accept__mailing') && this.permissions[node.id]['accept__mailing']);
    }
  }

  selectedNodeChange(e: any) {
    //
  }

  selectedUserChange(e: any) {
   this.emails = [];
   e.selectedRowsData.forEach((e: any) => {
     if (e.email) {
       this.emails.push(e.email)
     }
   })
  }

  onTemplateChange(e: any) {
    if (e.selectedItem?.id) {
      this.template.content = e.selectedItem.content;
    }
  }

  onTemplateApply() {
    if (this.template.content) {
      this.email_content = this.template.content;
    }
  }

  private customizeCell(e: any) {
    if (e.rowType !== 'data') {
      return;
    }

    if (e.data.accepted ) {
      e.cellElement.classList.add('status-cell_accepted');
    }
    if (e.data.accepted === false) {
      e.cellElement.classList.add('status-cell_not_accepted');
    }
  }

  @Watch("accept.id_year")
  async changeYear() {
    this.accept.id_cut = null;
  }

  @Watch("accept.id_cut")
  async dropCustomizationCell() {
    this.getFilials(true)
  }

  @Watch('data_source')
  onDataSourceChanged() {
    this.loadAllUserAccess();
    this.buildTreeSelection();
  }

  // @Watch('checked_nodes')
  // onCheckedNodesChanged() {
  //   this.buildTreeSelection();
  // }

  mounted() {
    this.buildTreeSelection();
  }

  buildTreeSelection() {
    // Формируем структуру для дерева филиал/ТУ
    const filialMap: { [key: string]: EcoFilialSelectionType } = {};
    (this.data_source as Array<{ filial_id: number; filial_name: string; id: number; name: string }>).forEach(node => {
      const filialKey = String(node.filial_id) + '_' + node.filial_name;
      if (!filialMap[filialKey]) {
        filialMap[filialKey] = {
          id: node.filial_id,
          name: node.filial_name,
          check: false,
          nodes: [],
        };
      }
      filialMap[filialKey].nodes.push({
        id: node.id,
        name: node.name,
        check: this.checked_nodes.includes(node.id),
      });
    });
    this.treeSelection = Object.values(filialMap);
  }

  onTreeSelectionChanged() {
    // Теперь checked_nodes обновляется автоматически через геттер/сеттер
    this.$forceUpdate(); // Обеспечить реактивность
  }

  get relative_cut() {
    let list = [];
    if (this.accept.id_year) {
      list = this.cut_ds.filter((c:any) => c.id_year === this.accept.id_year);
    }
    return list;
  }

  onClose() {
    this.shareService.closeAcceptPopup();
  }

  async onOk(e: any) {
    const resp = await this.acceptService.send_emails(this.emails, this.email_content);
    if (resp) {
      notify_service.info('Запущена процедура рассылки уведомлений')
      this.checked_users = [];

    }
  }

  empty() {
    //
  }

}
